const coupons = [200, 150, 125, 100, 100];

export default coupons;